import { format, differenceInYears, parse } from 'date-fns';

export const getYearsOldByDate = (date: string) => {
  const dataNascimento = parse(date, 'dd-MM-yyyy', new Date());
  const today = new Date();

  return differenceInYears(today, dataNascimento);
};
